module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-product",
    on: {
      "click": _vm.jump
    }
  }, [_c('swiper', {
    staticClass: "product-image",
    attrs: {
      "config": _vm.swiperConfig
    }
  }, _vm._l((_vm.data.images), function(img, index) {
    return _c('div', {
      directives: [{
        name: "key",
        rawName: "v-key",
        value: (index),
        expression: "index"
      }],
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "cover-line left"
    }), _vm._v(" "), _c('div', {
      staticClass: "cover-line right"
    }), _vm._v(" "), (_vm.data._big) ? _c('beast-image', {
      attrs: {
        "lazy": true,
        "src": _vm.data.bigPic.src
      }
    }) : _c('beast-image', {
      attrs: {
        "lazy": true,
        "src": img
      }
    }), _vm._v(" "), (_vm.data.foretell) ? _c('div', {
      staticClass: "corner-box"
    }, [_c('div', {
      staticClass: "stats-tag",
      class: {
        big: _vm.data._big
      }
    }, [_c('span', [_vm._v("即将开售")])])]) : _vm._e(), _vm._v(" "), (_vm.data.offShelf) ? _c('div', {
      staticClass: "corner-box"
    }, [_c('div', {
      staticClass: "stats-tag",
      class: {
        big: _vm.data._big
      }
    }, [_c('span', [_vm._v("下架")])])]) : _vm._e(), _vm._v(" "), (_vm.addToCart) ? _c('div', {
      staticClass: "add-cart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.addCart($event)
        }
      }
    }, [_c('beast-image', {
      attrs: {
        "src": "http://img.thebeastshop.com/apppictures/2017-07-12/6066758d9fb8834c2f2f6a9e4a085fa1.png"
      }
    })], 1) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "product-infos"
  }, [(_vm.data.activityDesc) ? _c('div', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.data.activityDesc))]) : _vm._e(), _vm._v(" "), (_vm.data.customizable) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("定制")]) : (_vm.data.isOversea) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("跨境商品")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "brand-name"
  }, [_vm._v(_vm._s(_vm.data.brand && _vm.data.brand.name))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.data.mainStationFirst) ? _c('div', {
    staticClass: "prices newn"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  }), _c('span', {
    staticClass: "newn-tag-shoudan"
  }, [_vm._v("首单价")])], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]) : (_vm.data.newcomerTag && !_vm.data.newcomerUsed) ? _c('div', {
    staticClass: "prices newn"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  }), _c('span', {
    staticClass: "newn-tag"
  }, [_vm._v("新人价")])], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "prices"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  })], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('del', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.data.stockWarn) ? _c('div', {
    staticClass: "stock-warn"
  }, [_vm._v(_vm._s(_vm.data.stockWarn || ''))]) : _vm._e()]), _vm._v(" "), (_vm.data.refunds) ? _c('div', {
    staticClass: "refund"
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.data.refunds)) + "元")]) : _vm._e(), _vm._v(" "), (_vm.data.soldOut) ? _c('div', {
    staticClass: "stats-tag-empty"
  }, [_c('span', [_vm._v("售罄")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e956e3c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/simple-product-new/index.vue
// module id = 174
// module chunks = 1 2 3 4 5 6 7 8 9 10 12 13 15 16 17 19 24 27 28 33 34 37 39 40 44 46